module.exports = __webpack_public_path__ + "img/dwbg.b6a5d63f.png";